import { render, staticRenderFns } from "./AboutCard.vue?vue&type=template&id=7fd9a2f0&scoped=true"
import script from "./AboutCard.vue?vue&type=script&lang=js"
export * from "./AboutCard.vue?vue&type=script&lang=js"
import style0 from "./AboutCard.vue?vue&type=style&index=0&id=7fd9a2f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd9a2f0",
  null
  
)

export default component.exports